// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e5J_","toggle":"styles_toggle__1Xalo","preview":"styles_preview__3rXdD"};